import Constants from './Constants.js';

/*
// Whether data exists
let dataExists = () => {

    const data = localStorage.getItem('data');

    // Test whether the data is null
    const isNull = data === null;
    if (isNull) return false;

    // Keys of stored data and default data
    let defaultData = getDefaultData();
    let defaultKeys = Object.keys(defaultData).sort();
    let storedKeys = Object.keys(JSON.parse(data)).sort();

    // Make sure the stored data contains the same keys as the default data
    return JSON.stringify(defaultKeys) === JSON.stringify(storedKeys);
}

// Return data, if it exists, or default data if it doesn't
let getData = () => {
    if (dataExists())
        return JSON.parse(localStorage.getItem('data'));
    return getDefaultData();
}

// Set data
let setData = (data) => {
    localStorage.setItem('data', JSON.stringify(data));
}
*/

// Whether each key matches up with a key in the default data
let keysMatch = () => {
    const data = localStorage.getItem('data');

    // Keys of stored data and default data
    let defaultData = getDefaultData();
    let defaultKeys = Object.keys(defaultData).sort();
    let storedKeys = Object.keys(JSON.parse(data)).sort();

    // Make sure the stored data contains the same keys as the default data
    return JSON.stringify(defaultKeys) === JSON.stringify(storedKeys);
}

// Whether data exists
let dataExists = () => {
    const data = localStorage.getItem('data');

    // Test whether the data is null
    const isNull = data === null;
    return !isNull;
}

// Return data, if it exists, or default data if it doesn't
let getData = () => {
    // Data does not exist
    if (!dataExists()) {
        return getDefaultData();
    }
    // Data exists in perfect condition
    else if (keysMatch()) {
        return JSON.parse(localStorage.getItem('data'));
    }
    // Fragmented data exists
    else {
        const defaultData = getDefaultData();
        let data = JSON.parse(localStorage.getItem('data'));

        // For each key in the stored data, copy it over to default data
        // (only if the default data has a corresponding key)
        Object.keys(data).forEach(function(key) {
            // Default data has a corresponding key, copy over data
            if (typeof defaultData[key] !== 'undefined') {
                defaultData[key] = data[key];
            }
        });
        return defaultData;
    }
}

// Set data
let setData = (data) => {
    localStorage.setItem('data', JSON.stringify(data));
}

// Get default data
let getDefaultData = () => {
    return {
        levelsBeat: [],
        currentLevel: 'number',
        hintsRemaining: Constants.startingHints,
        paidLevelsUnlocked: false,
        removedAds: false,
        rated: false,
        requestedRating: false,
    }
}




const LocalStorage = {
    getData: getData,
    setData: setData,
    dataExists: dataExists,
    getDefaultData: getDefaultData,
}

export default LocalStorage;
